export default __webpack_public_path__ + "static/media/genom-plusv2-hero.3acaf6ac.png";